module.exports = __webpack_public_path__ + "static/media/018.5e8b575f.jpg";